import { Component, OnInit, Input } from '@angular/core';
import { BehaviorSubject, Subject } from '../../../../node_modules/rxjs';
import { Telemetry } from '../../models/telemetry';

@Component({
  selector: 'app-playback-bar',
  templateUrl: './playback-bar.component.html',
  styleUrls: ['./playback-bar.component.scss']
})
export class PlaybackBarComponent implements OnInit {
  @Input('duration') duration:number;
  @Input('position') position: number;
  @Input('live') live: Subject<Telemetry>;

  public progress:number =0;
  constructor() {

  }

  ngOnInit() {
    this.progress = (100/this.duration)*this.position;

    if(this.live){
      this.live.subscribe(data=>{
        if(data.playbackPosition!=0){
          this.progress = (100/this.duration)*data.playbackPosition;
        }
        else{
          this.progress=0;
        }
      })
    }

  }

}
